import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, setTokenHeader, headers, isExpiredJwt, getJwtFromCookies, renderRedirect } from "../../module_auth/AuthService"
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"
import { AlertWarn } from "../../component/common/Alert"
import ReactQuill from 'react-quill';
import { LogoUploadButton } from '../common/LogoUploadButton';
import { useNavigate } from "react-router-dom";

export function MbrCpModiMypage() {
    const navigate = useNavigate();

    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [cpIntro, setCpIntro] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    
    // 기업회원가입시 사업자승인이 필요함
    const [validMbr, setvValidMbr] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");
    const [memberEntity, setMemberEntity] = useState("");

    //로고고
    const [logoEntity, setLogoEntity] = useState(null);
    const [showLogo, setShowLogo] = useState(false);

    //로고 업로드
    const [croppedImage, setCroppedImage] = useState(null); // 크롭된 이미지, 저장될 이미지
    const [fileName, setFileName] = useState('');

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    //modal
    const [showModal, setShowModal] = useState(false);

    const [showAlertWarn, setShowAlertWarn] = useState(false);
    const [alertWarnMessage, setAlertWarnMessage] = useState("사업자등록증과 대표님 신분증 사본을 이메일(gkoosoft@gmail.com)로 제출해주세요. 확인후 승인이 되면 구인 게재가 가능합니다.");

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            //alert
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/get/cp/mypage', 
                {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                    setCpName(response.cpName)
                    setCpAddress(response.cpAddress)
                    setCpIntro(response.cpIntro)
                    setFullname(response.fullname)
                    setTelno(response.telno)
                    setMobileNo(response.mobileNo)
                    setEmail(response.email)
                    setRecruiterName(response.recruiterName)
                    setRecruiterTelno(response.recruiterTelno)
                    setRecruiterEmail(response.recruiterEmail)
                    setvValidMbr(response.validMbr)
                    setShowAlertWarn(response.validMbr === 0);
                    setLogoEntity(response.logoEntity)
                    if(response.logoEntity){
                        setShowLogo(true)
                    } else {
                        setShowLogo(false)
                    }
            }).catch(error => console.log(error))
        }
    }, []);

    function changePasswordSubmit(event) {
        fetch(basePort + '/post/change/pwd', 
            {method:'post', headers,
                      body:JSON.stringify({
                        newPassword:password,
                        newPasswordRepeat:passwordRepeat,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                moveTo();
                            }.bind(this), 3000)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function handlePassword(event) {
        setPassword(event.target.value);
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handleEmail(event) {
        setEmail(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
    }

    function handleMobileNo(event) {
        setMobileNo(event.target.value);
    }

    function handleCpName(event) {
        setCpName(event.target.value);
    }

    function handleCpAddress(event) {
        setCpAddress(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleCpIntro(event) {
        setCpIntro(event.target.value);
    }

    function handleRecruiterName(event) {
        setRecruiterName(event.target.value);
    }

    function handleRecruiterTelno(event) {
        setRecruiterTelno(event.target.value);
    }

    function handleRecruiterEmail(event) {
        setRecruiterEmail(event.target.value);
    }

    function moveTo() {
        navigate("/mbr_cp_mypage");
    }

    function clickSubmit(event) {
        event.preventDefault();
        setAccessToken(getJwtFromCookies())
        fetch(basePort + '/post/cp/mypage', 
            {method:'post', headers,
                      body:JSON.stringify({
                        cpName:cpName,
                        cpAddress:cpAddress,
                        fullname:fullname,
                        cpIntro:cpIntro,
                        telno:telno,
                        mobileNo:mobileNo,
                        email:email,
                        recruiterName:recruiterName,
                        recruiterTelno:recruiterTelno,
                        recruiterEmail:recruiterEmail,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            //로고 저장
                            if(croppedImage != null){
                                //파일 업로드시
                                submitFile(response.id)
                            }
                            //submitFile(response.id)
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                moveTo()
                            }.bind(this), 3000)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function moveTo() {
        navigate("/mbr_cp_mypage");
    }

    function submitFile(id){
        setAccessToken(getJwtFromCookies())
        fetch(basePort + '/saveLogo',
                {method:'post', headers,
                    body:JSON.stringify({
                        imageData:croppedImage,
                        id:id,
                        fileName:fileName,
                        showLogo:showLogo
                    })})
                .then(response => response.json())
                .then(response => {
                    console.log("submitFile: " + response.validRequest)
                    if(response.validRequest){
                        console.log("submitFile success")
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo();
                        }.bind(this), 3000)
                    } else {
                        console.log("submitFile is not valid");
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    // 회원탈퇴
    function dropMbrSubmit(event) {
        event.preventDefault();
        fetch(basePort + '/post/dropMbr', 
            {method:'post', headers,
                      body:JSON.stringify({
                        cpName:cpName,
                        cpAddress:cpAddress,
                        cpIntro:cpIntro,
                        fullname:fullname,
                        telno:telno,
                        email:email,
                        password:password,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.jwtToken == null) {
                          
                        } else {
                       
                        }
            }).catch(error => console.log(error))
    }
    
    function closeModalBtn(){
        setShowModal(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        changePasswordSubmit()
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function handleImage(){
        //do nothing
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page" >
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>기업회원정보</span></li>
                        </ol>
                        {/* 기업정보 */}
                        <div class="card" style={{marginBottom: '10px'}}>
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <AlertWarn show={showAlertWarn} msg={alertWarnMessage} />
                                <form style={{marginTop: '10px'}}><label class="form-label">이메일(아이디):</label><input class="form-control" type="text" value={email} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">회사명:</label><input class="form-control" type="text" value={cpName} onChange={handleCpName} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">회사주소:</label><input class="form-control" type="text" value={cpAddress} onChange={handleCpAddress} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">대표자명:</label><input class="form-control" type="text" value={fullname} onChange={handleFullname} disabled/></form>
                                <form style={{marginTop:'10xp', margin: '10px', marginRight: '0', marginLeft: '0'}}>
                                    <label class="form-label">회사소개:</label>
                                    <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                        <ReactQuill theme="snow" value={cpIntro} onChange={setCpIntro}
                                            style={{height: '300px', marginBottom:'10px'}}
                                            modules={{
                                                toolbar: {
                                                    container: [
                                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                        [{ size: [] }],
                                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                                        ['image'],
                                                        ['clean'],
                                                        ['code-block']
                                                    ],
                                                    handlers: {
                                                        image: handleImage(),
                                                    },
                                                },
                                                
                                            }}
                                        />
                                    </div>
                                </form>

                                <LogoUploadButton
                                    croppedImage={croppedImage}
                                    setCroppedImage={setCroppedImage}
                                    setFileName={setFileName}
                                    logoEntity={logoEntity}
                                    setShowLogo={setShowLogo}
                                    showLogo={showLogo}
                                    />

                                <form style={{marginTop: '10px'}}><label class="form-label">전화번호:</label><input class="form-control" type="text" value={telno} onChange={handleTelno}/></form>
                                {/* <form style={{marginTop: '10px'}}><label class="form-label">휴대폰번호:</label><input class="form-control" type="text" value={mobileNo} onChange={handleMobileNo}/></form>
                                <form style={{marginTop: '20px'}}><label class="form-label">인사담당자명:</label><input class="form-control" type="text" value={recruiterName} onChange={handleRecruiterName}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">인사담당자 전화번호:</label><input class="form-control" type="text" value={recruiterTelno} onChange={handleRecruiterTelno}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">인사담당자 이메일:</label><input class="form-control" type="text" value={recruiterEmail} onChange={handleRecruiterEmail}/></form> */}
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}>
                                <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                                <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                            </form>
                        </div>
                        <div class="card" style={{marginBottom: '10px'}}>
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>비밀번호 변경</p>
                                <form><label class="form-label">새 비밀번호(8~16자의 영문, 숫자, 특수기호):</label><input class="form-control" type="password" onChange={handlePassword}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">새 비밀번호 확인:</label><input class="form-control" type="password" onChange={handlePasswordRepeat}/></form>
                                <ul class="list-group"></ul>
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}><button class="btn btn-primary" type="button" onClick={clickModalBtn}>비밀번호 변경하기</button></form>
                        </div>

                        {/* TODO: 회원탈퇴 */}
                        {/* <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>회원탈퇴</p>
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}><button class="btn btn-primary" type="button" onClick={dropMbrSubmit}>탈퇴하기</button></form>
                        </div> */}

                    {/* end of container */}
                    </div>
                    <ToastMessage show={showToast} msg={msgToast} />
                    <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"비밀번호 변경"} msg={"비밀번호를 변경하시겠습까?"} />

                </section>
            </main>
        </div>
    );
}